import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ReferrallItem').create(({ theme }) => ({
  root: {
    display: 'flex',
    minHeight: '68px',
    borderRadius: '8px',
    border: '1px solid',
    borderColor: 'rgba(255, 255, 255, 0.09)',
    background: 'rgba(255, 255, 255, 0.09)',
    width: '100%',
    alignItems: 'center',
    padding: '0px 8px',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },

  placeAndImgWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },

  imgWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },

  levelAndNameWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },

  img: {
    width: '48px',
    aspectRatio: '1/1',
    borderRadius: '8px',
  },

  valueWrapper: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },

  placeText: {
    fontWeight: 450,
    color: theme.colors.text.secondary,
    fontSize: '14px',
  },

  levelText: {
    fontWeight: 450,
    color: theme.colors.text.secondary,
    fontSize: '13px',
  },
  nameText: {
    fontWeight: 450,
    color: theme.colors.text.primary,
    fontSize: '14px',
  },

  valueText: {
    fontWeight: 440,
    color: theme.colors.text.primary,
    fontSize: '18px',
    fontFamily: 'Space Grotesk',
  },

  nameAndSubscriptionWrapper: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },

  nameTextChips: {
    fontWeight: 450,
    color: theme.colors.text.secondary,
    fontSize: '14px',
  },
}))
